import { FC } from "react";
import { Stack, Text } from "@chakra-ui/react";

import { ICooling } from "../../../../api/cooling/types.ts";
import { CoolingPageContractDetail } from "./CoolingPageContractDetail";
import { formatDate, formatPriceWithoutZeros, isStringWithNumber, isValidDate } from "../../../../utils";

interface Props {
  limitInfo: ICooling["limitInfo"];
}

export const CoolingPageContract: FC<Props> = ({ limitInfo }) => {
  const rawContractNumber = limitInfo?.contractNumber?.trim();
  const contractNumber = rawContractNumber ? `Договор займа №${rawContractNumber}` : "Договор займа";
  const amount = isStringWithNumber(limitInfo?.amount)
    ? formatPriceWithoutZeros(Number(limitInfo!.amount))
    : "";

  const startDateFormat = {
    day: "numeric",
    month: "long",
    year: "numeric",
  } as Intl.DateTimeFormatOptions;
  const contractStartDate = isValidDate(limitInfo?.contractStartDate)
    ? formatDate(new Date(limitInfo!.contractStartDate!), startDateFormat).replace(/\s*г\.?$/, "")
    : "";

  const endDateFormat = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  } as Intl.DateTimeFormatOptions;
  const cooldownEndDate = isValidDate(limitInfo?.cooldownEndDateTime)
    ? formatDate(new Date(limitInfo!.cooldownEndDateTime!), endDateFormat)
    : "";

  return (
    <Stack
      spacing={0}
      mt="20px"
      px="16px"
      pt="14px"
      pb="6px"
      bg="gray.25"
      border="1px solid"
      borderColor="gray.300"
      borderRadius="14px"
    >
      <Text variant="brand" fontSize="14px" mb="9px">{contractNumber}</Text>

      <CoolingPageContractDetail title="Сумма займа" value={amount} />
      <CoolingPageContractDetail title="Дата заключения договора" value={contractStartDate} />
      <CoolingPageContractDetail title="Дата и время окончания периода охлаждения" value={cooldownEndDate} isLast={true} />
    </Stack>
  );
};
